<template>
<div class="modal-dialog" :class="_class" role="document">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        is_centerd: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
        },
    },
    computed: {
        _class: function() {
            let _class = []

            if(this.is_centerd === true) {
                _class.push('modal-dialog-centered')
            }

            if(this.size) {
                _class.push('modal-'+this.size)
            }

            return _class
        }
    }
}
</script>